import type { Dispatch, AnyAction } from 'redux';

import * as BulkUpdatePerDiem from 'ab-api/web/employee/bulkUpdatePerDiem';
import type { W_PerDiem_BulkUpdate_RM } from 'ab-api/web/employee/bulkUpdatePerDiem';
import * as FindPerDiemForEmployeesOnWorkOrder from 'ab-api/web/employee/findPerDiemInfoForTimeSheet';
import type { W_Employee_PerDiemForTimeSheets_VM } from 'ab-api/web/employee/findPerDiemInfoForTimeSheet/viewModel';

import type { PerDiemWorkOrderEmployeeListViewModel } from 'ab-viewModels/perDiemWorkOrderEmployee.viewModel';
import type PerDiemWorkOrderEmployeeViewModel from 'ab-viewModels/perDiemWorkOrderEmployee.viewModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

import type { TableContent } from 'ab-common/dataStructures/tableContent';
import { TableQuery } from 'ab-common/dataStructures/tableQuery';

export function getPerDiemReportTable(tableRequestModel: TableQuery, startDate: string, endDate: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			const data = new TableQuery(tableRequestModel);
			return await http.get<TableContent<PerDiemWorkOrderEmployeeViewModel>>(API.V1.WORK_ORDER_EMPLOYEE.PER_DIEM.TABLE(data, startDate, endDate));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function getPerDiemReportForDateInterval(startDate: string, endDate: string, filterText: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<PerDiemWorkOrderEmployeeListViewModel>(API.V1.WORK_ORDER_EMPLOYEE.PER_DIEM.LIST(startDate, endDate, filterText));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function getPerDiemForEmployeesOnWorkOrder(workOrderId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<W_Employee_PerDiemForTimeSheets_VM>(FindPerDiemForEmployeesOnWorkOrder.URL(workOrderId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

interface PerDiemDataForUpdate {
	perDiemFlag: boolean;
	perDiemAmount: Nullable<string>;
}
export interface TimeSheetsBulkUpdate {
	[accountId: string]: { perDiemData: PerDiemDataForUpdate; };
}

export function bulkUpdatePerDiem(workOrderId: number, perDiemObj: TimeSheetsBulkUpdate) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.put<W_PerDiem_BulkUpdate_RM>(BulkUpdatePerDiem.URL(workOrderId), perDiemObj);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
